import { render, staticRenderFns } from "./ChatRobot.vue?vue&type=template&id=3b77834c&scoped=true&"
import script from "./ChatRobot.vue?vue&type=script&lang=js&"
export * from "./ChatRobot.vue?vue&type=script&lang=js&"
import style0 from "./ChatRobot.vue?vue&type=style&index=0&id=3b77834c&scoped=true&lang=css&"
import style1 from "./ChatRobot.vue?vue&type=style&index=1&id=3b77834c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b77834c",
  null
  
)

export default component.exports